var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg32IconAround(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2074",
    "data-name": "Group 2074",
    transform: "translate(-1898.13 -2316.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_32_icon_360",
    "data-name": "32/icon/360",
    transform: "translate(1898.13 2316.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1908",
    "data-name": "Rectangle 1908",
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fffefa",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(0.131 -16.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M20.961,34.275c2.308-.7,3.817-1.867,3.817-3.184,0-2.144-3.989-3.881-8.909-3.881S6.96,28.947,6.96,31.089s3.989,3.881,8.909,3.881c.691,0,1.364-.035,2.012-.1",
    fill: "none",
    stroke: "#fffefa",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M45.891,50.35l2.873,2.873L45.85,56.137",
    transform: "translate(-30.84 -18.35)",
    fill: "none",
    stroke: "#fffefa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32IconAround);
export default __webpack_public_path__ + "static/media/32-icon-around.c8235879.svg";
export { ForwardRef as ReactComponent };